import React, { useState } from 'react';
import {
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import { RailsFacetItemMeta } from '@sls-react/typings/services/rails/facets';
import SimpleFade from '@sls-react/components/Transitions/SimpleFade';
import { NegativeFeedbackIcon } from '@sls-react/static/svg/FeedbackIcons';
import ItemThumbnailOverlayActions from '@sls-react/components/ItemThumbnail/ActionsOverlay/ItemThumbnailOverlayActions';
import SwipeableViews from 'react-swipeable-views';
import SellerQualityScoreTooltip from '@sls-react/components/ItemThumbnail/ActionsOverlay/SellerQualityScoreTooltip';
import ArrowRightIcon from '@sls-react/static/svg/ArrowRightIcon';
import { ArrowLeftIcon } from '@sls-react/components/Icons/ArrowIcons';

interface Props {
  item: RailsThumbnailItem | RailsItem;
  meta?: RailsFacetItemMeta;
  onClose?: () => void;
  onInvalidate?: () => void;
  show: boolean;
}

const ItemThumbnailOverlay: React.FC<Props> = ({
  item,
  meta,
  onClose,
  onInvalidate,
  show,
}) => {
  const [index, setIndex] = useState(0);
  return (
    <SimpleFade
      show={show}
      className="absolute inset-0 z-20 py-2 overflow-y-auto text-white rounded-lg bg-true-black bg-opacity-90"
    >
      <div className="flex justify-between px-3 mb-2">
        <SimpleFade
          as="button"
          show={index !== 0}
          className="w-4 h-4"
          onClick={() => setIndex(0)}
        >
          <ArrowLeftIcon />
        </SimpleFade>

        <button className="ml-auto" onClick={onClose}>
          <NegativeFeedbackIcon
            className="w-6 h-6 stroke-current"
            strokeWidth={2}
          />
        </button>
      </div>

      <SwipeableViews index={index} disabled slideClassName="px-3">
        <div className="mb-4 space-y-1">
          <ItemThumbnailOverlayActions
            item={item}
            meta={meta}
            onInvalidate={() => {
              onInvalidate?.();
              onClose?.();
            }}
            onViewQualityScore={() => setIndex(1)}
          />
        </div>

        {meta?.quality_score && (
          <div>
            <SellerQualityScoreTooltip score={meta?.quality_score} />
          </div>
        )}
      </SwipeableViews>
    </SimpleFade>
  );
};

export default ItemThumbnailOverlay;
